module.exports = __webpack_public_path__ + "img/logo-ncshszh.f9816289.jpg";